import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, allowedRole }) {
  const { user, roles, activeRole, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-500" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (
    allowedRole &&
    (!roles?.includes(allowedRole) || activeRole !== allowedRole)
  ) {
    const home = activeRole === "rider" ? "/rider" : "/seller";
    return <Navigate to={home} replace />;
  }

  return children;
}
